/* eslint-disable react/prop-types */
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import './styles.css';
import { useContext, useEffect, useState } from 'react';
import { Context } from '../../hooks/useAuthContext';
import api from '../../services/axiosConfig';
import ModalDetalheMensagem from './components/ModalDetalheMensagem/ModalDetalheMensagem';

function ModalMensagens({ isOpen, toggle, onMessagesUpdate }) {
  const { userData } = useContext(Context);
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);  

  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const toggleDetailModal = () => setDetailModalOpen(!detailModalOpen);

  const handleMessageClick = async (message) => {
    setSelectedMessage(message); 
    setDetailModalOpen(true);  

    if (!message.read) {
      try {
        await api.post(`/mensagens/${message._id}/read`, { userId: userData._id });
        
        setMessages(prevMessages =>
          prevMessages.map(m =>
            m._id === message._id ? { ...m, read: true } : m
          )
        );

        onMessagesUpdate();
      } catch (err) {
        console.error("Falha ao marcar mensagem como lida:", err);
      }
    }
  };

  const handleMarkAsUnread = async (messageId) => {
    try {
      await api.delete(`/mensagens/${messageId}/unread`, {
        data: { userId: userData._id }
      });

      setMessages(prevMessages =>
        prevMessages.map(m =>
          m._id === messageId ? { ...m, read: false } : m
        )
      );
      
      setDetailModalOpen(false);
      onMessagesUpdate();
    } catch (err) {
      console.error("Falha ao marcar mensagem como não lida:", err);
    }
  };

  useEffect(() => {
    const fetchMessages = async () => {
      if (!userData?._id) return;

      setIsLoading(true);
      setError(null);
      try {
        const response = await api.get(`/mensagens/listar-mensagem?userId=${userData._id}`);
        setMessages(response.data);
      } catch (err) {
        setError("Não foi possível carregar as mensagens.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (isOpen) {
      fetchMessages();
    }
  }, [isOpen, userData?._id]);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  const renderContent = () => {
    if (isLoading) {
      return <div className="text-center"><Spinner color="warning" /></div>;
    }
    if (error) {
      return <p className="text-center text-danger">{error}</p>;
    }
    if (messages.length === 0) {
      return <p className="text-center">Nenhuma mensagem encontrada.</p>;
    }

    const unreadMessages = messages.filter(msg => !msg.read);
    const readMessages = messages.filter(msg => msg.read);

    return (
      <div className="message-list-container">
        {unreadMessages.length > 0 && (
          <ul className="message-list">
            {unreadMessages.map((msg) => (
              <li key={msg._id} className="message-item" onClick={() => handleMessageClick(msg)}>
                <div className="message-content">
                  <strong>{msg.title}</strong>
                  <p>{truncateText(msg.body, 18)}</p>
                </div>
                <span className="unread-dot"></span>
              </li>
            ))}
          </ul>
        )}

        {readMessages.length > 0 && (
          <div className="messages-separator">
            Últimas 10 mensagens lidas
          </div>
        )}

        {readMessages.length > 0 && (
          <ul className="message-list">
            {readMessages.map((msg) => (
              <li key={msg._id} className="message-item" onClick={() => handleMessageClick(msg)}>
                <div className="message-content">
                  <strong>{msg.title}</strong>
                  <p>{truncateText(msg.body, 18)}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <>
        <Modal isOpen={isOpen} toggle={toggle} centered scrollable>
          <ModalHeader toggle={toggle}>
              Mensagens
          </ModalHeader>
          <ModalBody>
              {renderContent()}
          </ModalBody>
      </Modal>
      <ModalDetalheMensagem
          isOpen={detailModalOpen}
          toggle={toggleDetailModal}
          message={selectedMessage}
          onMarkAsUnread={handleMarkAsUnread} 
      />
    </>
  );
}

export default ModalMensagens;